import React from 'react';
import { Select } from '@scale/scaleui-radix';
import { TimeOptions } from 'react-scale/components/WebinarSessions/components/TimePicker';

interface TimePickerProps {
  time: string;
  setTime: (time: string) => void;
  disabled?: boolean;
}

export const TimePicker: React.FC<TimePickerProps> = ({ time, setTime, disabled }) => {
  return (
    <Select.Root size="2" value={time} onValueChange={setTime} disabled={disabled}>
      <Select.Trigger disabled={disabled} />
      <Select.Content
        position="popper"
        style={{
          height: '200px',
          overflowY: 'auto',
        }}
      >
        {TimeOptions.map(option => (
          <Select.Item key={option.id} value={option.id}>
            {option.name}
          </Select.Item>
        ))}
      </Select.Content>
    </Select.Root>
  );
};
